import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import taxesService from './taxesServices';

const initialState = {
  taxCreateState: '',
  taxesIsError: false,
  taxesIsSuccess: false,
  taxesIsLoading: false,
  taxesIserrorMsg: '',
  // get taxes rates
  getTaxRateList: [],
  getTaxesListStatus: '',
  getTaxRateListSuccess: false,
  getTaxRateListError: false,
  getTaxRateListLoading: false,
  getTaxRateListErrorMsg: '',

  // delete tax
  deleteTaxRateStausState: '',
  deleteTaxRateSuccess: false,
  deleteTaxRateError: false,
  deleteTaxRateLoading: false,
  deleteTaxRateErrorMsg: '',
  // change status
  statusTaxRateState: '',
  statusTaxRateSuccess: false,
  statusTaxRateError: false,
  statusTaxRateLoading: false,
  statusTaxRateErrorMsg: '',
};

// creatingTaxes
export const creatingTaxes = createAsyncThunk(
  'createTax/creatingTaxes',

  async (user, thunkAPI) => {
    try {
      return await taxesService.creatingTaxes(user);
    } catch (error) {
      const taxesIserrorMsg =
        (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
      return thunkAPI.rejectWithValue(taxesIserrorMsg);
    }
  }
);

// ______________taxe lists _______________
export const getAllTaxRate = createAsyncThunk('getTax/getAllTaxRate', async (user, thunkAPI) => {
  try {
    return await taxesService.getAllTaxRate(user);
  } catch (error) {
    const getTaxRateListErrorMsg =
      (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(getTaxRateListErrorMsg);
  }
});

// ____________delete taxes ____________

export const deleteTaxRate = createAsyncThunk('delteTax/deleteTaxRate', async (data, thunkAPI) => {
  try {
    return await taxesService.deleteTaxRate(data);
  } catch (error) {
    const errorMsg =
      (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(errorMsg);
  }
});

// ____________changeStatus taxes ____________

export const changeTaxStatus = createAsyncThunk('statusTax/changeTaxStatus', async (data, thunkAPI) => {
  try {
    return await taxesService.changeTaxStatus(data);
  } catch (error) {
    const errorMsg =
      (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(errorMsg);
  }
});

export const taxSlice = createSlice({
  name: 'taxes',
  initialState,
  reducers: {
    reseTaxesStatus: (state) => {
      state.taxCreateState = '';
      state.taxesIsLoading = false;
      state.taxesIsSuccess = false;
      state.taxesIsError = false;
      state.taxesIserrorMsg = '';
      // after  delete
      state.deleteTaxRateStausState = '';
      state.deleteTaxRateSuccess = false;
      state.deleteTaxRateError = false;
      state.deleteTaxRateLoading = false;
      state.deleteTaxRateErrorMsg = '';
      // list
      // state.getTaxRateList= [];
      // gtaxetTaxesListStatus= '';
      state.getTaxRateListSuccess = false;
      state.getTaxRateListError = false;
      state.getTaxRateListLoading = false;
      state.getTaxRateListErrorMsg = '';
      // status
      state.statusTaxRateSuccess = false;
      state.statusTaxRateError = false;
      state.statusTaxRateLoading = false;
      state.statusTaxRateErrorMsg = '';
    },
    updateTaxList: (state, action) => {
      state.getTaxRateList = action.payload;
      // console.log(current(state.getTaxRateList))
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(creatingTaxes.pending, (state) => {
        state.taxesIsLoading = true;
      })
      .addCase(creatingTaxes.fulfilled, (state, action) => {
        state.taxesIsLoading = false;
        state.taxesIsSuccess = true;
        state.taxCreateState = action.payload;
      })
      .addCase(creatingTaxes.rejected, (state, action) => {
        state.taxesIsLoading = false;
        state.taxesIsError = true;
        state.taxesIserrorMsg = action.payload;
      })

      // get tax rates
      .addCase(getAllTaxRate.pending, (state) => {
        state.getTaxRateListLoading = true;
      })
      .addCase(getAllTaxRate.fulfilled, (state, action) => {
        state.getTaxRateListLoading = false;
        state.getTaxRateListSuccess = true;
        state.getTaxesListStatus = action.payload;
        state.getTaxRateList = action.payload.getAllTaxRate;
      })
      .addCase(getAllTaxRate.rejected, (state, action) => {
        state.getTaxRateListLoading = false;
        state.getTaxRateListError = true;
        state.getTaxRateListErrorMsg = action.payload;
      })
      // delete tax
      .addCase(deleteTaxRate.pending, (state) => {
        state.deleteTaxRateLoading = true;
      })
      .addCase(deleteTaxRate.fulfilled, (state, action) => {
        state.deleteTaxRateLoading = false;
        state.deleteTaxRateSuccess = true;
        state.deleteTaxRateStausState = action.payload;
      })
      .addCase(deleteTaxRate.rejected, (state, action) => {
        state.deleteTaxRateLoading = false;
        state.deleteTaxRateError = true;
        state.deleteTaxRateErrorMsg = action.payload;
      })

      // change tax status

      .addCase(changeTaxStatus.pending, (state) => {
        state.statusTaxRateLoading = true;
      })
      .addCase(changeTaxStatus.fulfilled, (state, action) => {
        state.statusTaxRateLoading = false;
        state.statusTaxRateSuccess = true;
        state.statusTaxRateState = action.payload;
      })
      .addCase(changeTaxStatus.rejected, (state, action) => {
        state.statusTaxRateLoading = false;
        state.statusTaxRateError = true;
        state.statusTaxRateErrorMsg = action.payload;
      });
  },
});

export const { reseTaxesStatus, updateTaxList } = taxSlice.actions;
export default taxSlice.reducer;
